import type { ZodType } from 'zod';
import { rule } from '@ast-data/shared';

/**
 * A record schema with fields that only the FORM insists on.
 *
 * The Bearbeiter, Autor, Fotograf and Zeichner stay optional in the shared
 * schema: the grid's inline editing and the Sammelbearbeitung validate the
 * whole row, and the ExcaBook import validates what it reads in — a record that
 * already has no name in it would be blocked there, over a field nobody
 * touched. The dialog is where a name is entered (and prefilled), so that is
 * where an emptied one is caught.
 *
 * A field counts as empty when it is blank, or a list of names with none in it.
 */
export function requiredInForm<Schema extends ZodType>(
    schema: Schema,
    fields: readonly string[]
): Schema {
    return schema.superRefine((value, ctx) => {
        const record = value as Record<string, unknown>;
        for (const field of fields) {
            const current = record[field];
            const isEmpty = Array.isArray(current)
                ? current.every((item) => `${item ?? ''}`.trim() === '')
                : `${current ?? ''}`.trim() === '';
            if (isEmpty) {
                ctx.addIssue({
                    code: 'custom',
                    path: [field],
                    message: rule('required')
                });
            }
        }
    }) as unknown as Schema;
}
